/* @jsx h */
import { h } from "preact";
import ChecklistProvider from "./context";
import ChecklistPage from "./views/ChecklistPage";
import "../scss/styles.scss";

function App() {
    return (
        <ChecklistProvider>
            <ChecklistPage />
        </ChecklistProvider>
    );
}

export default App;
